import * as React from 'react';
import { useSelector } from 'react-redux';
import { ArticleHeading1 } from '@cian/ui-kit';
import { ActionAfterViewed } from '@cian/action-after-viewed-component';
import { SpecialPromos as SpecialPromosComponent } from '../../components/SpecialPromos';
import { Promos } from '../Promos';
import { Discounts } from '../Discounts';
import { showSpecialPromos } from '../../selectors';
import { trackShowSpecialPromos } from './tracking';

export function SpecialPromos() {
  const showBlock = useSelector(showSpecialPromos);

  if (!showBlock) {
    return null;
  }

  return (
    <ActionAfterViewed callback={trackShowSpecialPromos}>
      <SpecialPromosComponent
        title={<ArticleHeading1>Акции и спецпредложения</ArticleHeading1>}
        slider={<Promos />}
        discounts={<Discounts />}
      />
    </ActionAfterViewed>
  );
}
